import layout from './layout';

const rootReducer = { layout };

export default rootReducer;
